import React from 'react';
import '../../styles/c_HomeAteliers.css';
import { useHomeData } from '../../hooks/useHomeData';

function HomeAteliers() {
    const { data } = useHomeData();
    const ateliersData = data?.ateliers;

    if (!ateliersData?.title) {
        return <div className="loadingFiller"></div>;
    }

    return (
        <>
            <div id='homeAteliersWrapper'>
                <div className="homeAteliersContent">
                    <h2 className='homeAteliersTitle'><a href={ateliersData.button.href} target="_blank" rel="noreferrer">{ateliersData.title}</a></h2>
                    <p className='homeAteliersSubtitle'>{ateliersData.subtitle}</p>
                    <p className='homeAteliersDescription'>{ateliersData.description}</p>
                    <p className='homeAteliersCallout'>{ateliersData.callout}</p>
                    <a className='homeAteliersBtn' href={ateliersData.button.href} target="_blank" rel="noreferrer">{ateliersData.button.text}</a>
                </div>
                <div className="homeAteliersImage">
                    <img src={ateliersData.image.path} alt={ateliersData.image.alt} loading='lazy' decoding='async' />
                </div>
            </div>
        </>
    );
}

export default HomeAteliers;
